const tipos={MESA:'Mesa',LOUNGE:'Lounge',PALCO:'Palco',SUPER_VIP:'Super VIP'};
const normal=s=>String(s||'').toUpperCase().replace(/[\s-]/g,'');
const ref=s=>typeof s==='string'&&/^[A-Za-z0-9_-]{1,100}$/.test(s);
export function gruposAplicacionPaquete(escena){
 return (escena?.floors||[]).flatMap(f=>Object.entries(tipos).map(([tipo,nombre])=>({id:f.id+'::'+tipo,pisoId:f.id,pisoNombre:f.name,tipo,label:nombre+' · '+f.name,zonas:(escena.objects||[]).filter(o=>o.reservable&&o.floorId===f.id&&o.zoneType===tipo).map(o=>o.id)})).filter(g=>g.zonas.length));
}
export function validarAplicacionPaquete(a){
 if(!a||!ref(a.recintoId)||!Number.isInteger(a.version)||a.version<1||!Array.isArray(a.zonas)||!a.zonas.length||a.zonas.length>500||a.zonas.some(z=>!ref(z))||new Set(a.zonas).size!==a.zonas.length)throw Error('Selecciona un recinto publicado y al menos un grupo de zonas.');
 return {recintoId:a.recintoId,version:a.version,zonas:[...a.zonas],resumen:Array.isArray(a.resumen)?a.resumen.filter(s=>typeof s==='string'&&s.length<=200).slice(0,48):[]};
}
export function paqueteParaZona(paquete,tipo,zonaId,contexto){
 if(!paquete?.aplicaA?.includes(tipo))return false;
 const a=paquete.aplicacionRecinto;if(!a)return true;
 return !!contexto&&a.recintoId===contexto.recintoId&&a.version===contexto.version&&Array.isArray(a.zonas)&&a.zonas.some(id=>normal(id)===normal(zonaId));
}

// Una lista reutilizada conserva exactamente sus zonas, incluso en copias del recinto.
export function adaptarAplicacionPaquete(aplicacion,origen,destino,contexto){
 const a=validarAplicacionPaquete(aplicacion);
 if(!contexto?.recintoId||!Number.isInteger(contexto.version))return null;
 const fuente=new Map((origen?.objects||[]).map(o=>[o.id,o]));
 const llegada=new Map((destino?.objects||[]).map(o=>[o.id,o]));
 if(a.zonas.some(id=>{const x=fuente.get(id),y=llegada.get(id);return !x?.reservable||!y?.reservable||x.floorId!==y.floorId||x.zoneType!==y.zoneType||x.capacity!==y.capacity;}))return null;
 return {...a,recintoId:contexto.recintoId,version:contexto.version};
}
